import React from "react";
import Variant from "./variant";
// import ClassNames from 'classnames'

class Selector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVariant: 1
    };

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(n) {
    this.setState({ selectedVariant: n });
    this.props.onSelectVariant(n);
  }

  appendToFilename ( filename, string ) {
    let dotIndex = filename.lastIndexOf( "." );
    if ( dotIndex === -1 ) {
      return filename + string;
    } else {
      return filename.substring( 0, dotIndex ) + string + filename.substring( dotIndex );
    }
  }

  render() {
    let sku = "749353336876";
    let url = "https://www.drinkyogaflow.com";

    return (
      <div className="Selector">
        <ul id="BuyNow" className="steps">
          <li className="active">
            <span className="number">1</span>
            Select Package
          </li>
          <li>
            <span className="number">2</span>
            Payment Info
          </li>
          <li>
            <span className="number">3</span>
            Thank You
          </li>
        </ul>
        <div className="variants">
          <h4>Select quantity</h4>
          <ul>
            {this.props.product.variants.map((variant, i) => {
              return (
                <Variant
                  selected={i === this.state.selectedVariant}
                  data={variant}
                  key={i}
                  n={i}
                  handleSelect={this.handleSelect}
                  originalPerBoxPrice={this.props.product.variants[0].price}
                />
              );
            })}
          </ul>
        </div>

        <div className="image">
          <div
            className="yotpo bottomLine"
            data-product-id={sku}
            data-url={url}
          />
          <img src={ this.props.product.images[0].originalSrc } />
        </div>

        <div className="intro-testimonial">
          <div className="profile">
            <img className="profile__image" src="/images/buy/anne-lane-salice.png" />
            <div className="profile__container">
              <span className="name">Anne Salice</span>
              <span className="quote">Worth Every Penny</span>
            </div>
          </div>
          <div className="text">
            <p>I didn’t know if it would be worth trying Yoga Flow, but I liked the ingredients. They are simple and beneficial for me. I don't like eating processed stuff with chemicals that need to be detoxed from my body.</p>
            <p>And then I thought, well, it's more like, am I worth it? So I decided that I was, and I gave it a try. Well, I love it.</p>
            <p>It tastes a lot better than I thought it would. It’s not sugary sweet but not bland, so it’s something I drink regularly. And Ashwagandha is great for stress relief.</p>
          </div>
        </div>

        <div className="benefits">
          <ul>
            <li onClick={this.props.handleFreeShippingInfo}>Free Shipping</li>
            <li onClick={this.props.handleRefundPolicyInfo}>100% Satisfaction Guarantee</li>
            <li onClick={this.props.handleNutritionalInfo}>Nutritional Info</li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/buy/selector.js